import React from 'react';
import styles from './ShadowSeparator.styles';
import curvedShadow from '../../../assets/images/curved-shadow.svg';

const ShadowSeparator = () => (
    <img style={styles.curvedShadow} src={curvedShadow} />
);


export default ShadowSeparator;



// WEBPACK FOOTER //
// ./src/app/components/UI_Elements/ShadowSeparator.js